import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {HelpersService} from '../../../services/helpers.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';
import {MemberService} from '../../../services/member.service';
import {DocumentsApiService} from '../../../services/api/documents-api.service';
import {RegistryFileModel} from '../../../models/file.model';
import {PaginationModel} from '../../../models/file-table.model';

@Component({
    selector: 'app-registry-documents',
    templateUrl: './registry-documents.component.html',
    styleUrls: ['registry-documents.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({overflow: 'unset'})),
            transition(':enter', [style({overflow: 'hidden', height: 0}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({overflow: 'hidden', height: 0})))
        ])
    ]
})
export class RegistryDocumentsComponent implements OnInit {
    @ViewChild('docView') public docView: TemplateRef<any>;

    public data: RegistryFileModel[] = [];
    public loading = false;
    public docKey: string;

    pagination: PaginationModel;

    constructor(
        protected documentApi: DocumentsApiService,
        protected modal: ModalService,
        protected alert: AlertService,
        protected memberService: MemberService,
        public helpers: HelpersService,
        protected modalService: ModalService,
    ) {
    }

    ngOnInit(): void {
        this.pagination = {
            limit: 15,
            current_page: 1,
        };
        this.getRegistry();
    }

    collapse(index: number): void {
        if (!this.data[index].collapse) {
            for (const item of this.data) {
                item.collapse = false;
            }
            this.data[index].collapse = true;
        } else {
            this.data[index].collapse = false;
        }
    }

    openProfile(guid: string): void {
        this.helpers.openProfileByGuid(guid);
    }

    getRegistry(): void {
        this.loading = true;
        this.documentApi.getRegistry(this.pagination).subscribe({
            next: data => {
                this.pagination.pages = data.page_count;
                this.data = data.data;
                this.getAllSigners();
                this.loading = false;
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
                this.loading = false;
            }
        });
    }

    getAllSigners(): void {
        let allSigners = [];
        this.data.forEach(file => {
            allSigners = allSigners.concat(
                file.signers_guids.map(signer => {
                    return signer.member_guid;
                })
            );
        });

        this.memberService.memberGuidsHandler(allSigners).then(members => {
            this.data.forEach(file => {
                file.signers_guids.forEach(signer => {
                    signer.user = members.find(member => member.guid === signer.member_guid);
                });
            });
        });
    }

    changePage(newPage: number): void {
        this.pagination.current_page = newPage;
        this.getRegistry();
    }

    navigateDoc(doc: RegistryFileModel, event?: MouseEvent): void {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        this.docKey = doc.key;
        this.modalService.openTemplateModal(this.docView, 'xl');
    }
}
